import tw from "tailwind-styled-components";

// Navbar Categories Skeleton Loading Component
export const NavbarCategoriesLoading = () => (
  <NavbarContainer>
    {[...Array(12)].map((_, index) => (
      <NavbarItem key={index}>
        <NavbarCategoryImages />
        <NavbarText />
      </NavbarItem>
    ))}
  </NavbarContainer>
);

// Styled Components
// const NavbarContainer = tw.div`flex space-x-6 overflow-x-auto px-6 w-full scrollbar-hide`;
const NavbarContainer = tw.div`flex items-start space-x-3 sm:space-x-6 lg:space-x-8 overflow-x-auto px-4 sm:px-6 lg:px-8 w-full scrollbar-hide`;
const NavbarItem = tw.div`flex flex-col items-center space-y-2 animate-pulse py-3 px-4`;
const NavbarCategoryImages = tw.div`w-20 h-20 bg-gray-200`;
const NavbarText = tw.div`bg-gray-200 h-4 w-20 rounded`;
